/* eslint-disable no-unused-vars */
import { login, logout, getUserInfo } from '@/api/user'
import {getToken, setToken, removeToken, setUserInfo, getCachedUserInfo} from '@/utils/auth'

const state = {
  token: getToken(),
    name: '',
    userId: '',
    role: '',
    email:'',
    ...getCachedUserInfo()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERID: (state, id) => {
    state.userId = id
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
    SET_EMAIL: (state, email) => {
        state.email = email
    }
}

const actions = {
  login({ commit, dispatch }, userInfo) {
    const { userId, password, captchaId, captchaCode } = userInfo
    return new Promise((resolve, reject) => {
      login({ userId: userId.trim(), password: password, captchaId, captchaCode })
          .then(response => {
            const { data } = response
            if(response.code === 200){
              commit('SET_TOKEN', data)
              setToken(data)
              // 等待获取用户信息完成后再resolve
              dispatch('getInfo').then(() => {
                resolve()
              })
            } else {
              reject(response.message)
            }
          })
          .catch(error => {
            reject(error)
          })
    })
  },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo()
          .then(response => {
            const { data } = response
            const userInfo = {
              userId: data.userId,
              name: data.name,
              role: data.role,
                email:data.email
            }
            console.log("userInfo:",response)
            commit('SET_USERID', data.userId)
              commit('SET_EMAIL', data.email)
            commit('SET_NAME', data.name)
            commit('SET_ROLE', data.role)

            setUserInfo(userInfo) // 保存到localStorage

            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
    })
  },

  // 用户登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('SET_TOKEN', '')
          commit('SET_NAME', '')
          commit('SET_USERID', '')
          commit('SET_ROLE', '')
            commit('SET_EMAIL', '')

          removeToken()
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 重置token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_NAME', '')
      commit('SET_USERID', '')
      commit('SET_ROLE', '')
        commit('SET_EMAIL', '')

      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
